export function isValidGtin(gtin) {
    if (gtin.length !== 13 || isNaN(gtin))
        return false;

    let sumOfOdd = 0, sumOfEven = 0;
    for (let i = 0; i < gtin.length; i++) {
        const position = i + 1;
        const value = parseInt(gtin[i]);
        if (position % 2 === 0) {
            sumOfEven += value;
        } else {
            sumOfOdd += value;
        }
    }

    let sum = sumOfOdd + 3 * sumOfEven;
    return sum % 10 === 0;
};


export function isURL(url) {
    try {
        const parsedUrl = new URL(url);
        const hostname = parsedUrl.hostname;
        const pathname = parsedUrl.pathname;

        if (hostname.includes('n11.com')) {
            const pattern = /urun\/[^-]*-([^-?]*)/;
            const match = pathname.match(pattern);
            if (match && match[1]) {
                return match[1];
            }
        }
        return null;
    } catch (error) {
        return null;
    }
}


export function extractGroupId(url) {

    const patternBeforeQuestionMark = /-([0-9]{4,10})\?/;
    const matchBeforeQuestionMark = url.match(patternBeforeQuestionMark);
  
    if (matchBeforeQuestionMark && matchBeforeQuestionMark[1]) {
      return matchBeforeQuestionMark[1];
    }
  

    const patternAfterLastDash = /-([0-9]{4,10})$/;
    const matchAfterLastDash = url.match(patternAfterLastDash);
  
    if (matchAfterLastDash && matchAfterLastDash[1]) {
      return matchAfterLastDash[1];
    }
  
 
    return null;
}

export function isAlphaOrAlphaNumeric(str) {
    if (/^\d+$/.test(str)) {
        return false;
    }
    const regex = /^[a-zA-ZçÇğĞıİöÖşŞüÜ\s\d!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]*$/;
    return regex.test(str);
}